import React, { useEffect, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import "./CourseManagement.scss";
import { Row, Col, InputGroup, Form } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { toast } from "react-toastify";
import WebService from "../../Services/WebService";
import HelperService from "../../Services/HelperService";
import Loader from "../../components/Loader/Loader";
import LevelDeleteModal from "../../components/LevelDeleteModal/LevelDeleteModal";
import { Link, useNavigate, useParams } from "react-router-dom";
import ShareService from "../../Services/ShareService";
import Grid, {
  GridColumn,
  GridHeader,
  GridRow,
} from "../../components/Grid/Grid";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useLocation } from "react-router-dom";

const CourseManagement = () => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [ShowLoader, setShowLoader] = useState(false);
  const [FilterObj, setFilterObj] = useState<any>({});
  const [Count, setCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [request, setRequest] = useState<any>("");
  const [permissions, setPermissions] = useState({
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
  });
  const [types, setTypes] = useState<any[]>([]);
  const [activeType, setActiveType] = useState<string>("VFR");
  const [allData, setAllData] = useState<any[]>([]);
  const location = useLocation();

const query = new URLSearchParams(location.search);

const type = query.get("type");
const usedFor = query.get("used_for");
const certificateTitle = query.get("certificate_title") || "";
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    typeList();
    console.log(type);
  }, []);

  useEffect(() => {
    if (activeType) {
      getlist(1, searchKeyword);
    }
  }, [activeType]);
  // NOTE: `type` is a used_for value (COURSE / CERTIFICATE), NOT a course tab
  // value (VFR / IFR). It must never be written into `activeType`, otherwise the
  // VFR/IFR filtering breaks and both backend + frontend return no rows.
  const onchange = (currentPage: number, searchText?: string) => {
    let obj: any = { ...FilterObj };
    obj.offset = currentPage ? currentPage - 1 : 0;
    obj.keyword = searchText !== undefined ? searchText : searchKeyword;
    ShareService.setMapValue("listing-levels-filter", obj);
    setFilterObj(obj);
    getlist(currentPage, obj.keyword);
  };

  const onSort = (sortKey: string, order: string, sort_by: any) => {
    const obj: any = { ...FilterObj };
    const orderBy = order ? "asc" : "desc";
    obj.sort_by = sort_by;
    obj.order_by = orderBy;
    ShareService.setMapValue("listing-levels-filter", obj);
    setFilterObj(obj);
    getlist(1, obj.keyword, orderBy, sort_by);
  };

  const typeList = () => {
    setShowLoader(true);
   const usedForParam = usedFor ?? "COURSE";
    const typeParam = type ? `&type=${type}` : "";
    WebService.getAPI({
     action: `/courses?used_for=${usedForParam}&type=${type ?? ""}`,
      body: null,
    })
      .then((res: any) => {
        setShowLoader(false);
        setTypes(res.list);
        if (res.list && res.list.length > 0 && !activeType) {
          setActiveType(res.list[0].type);
        }
      })
      .catch((e: any) => {
        setShowLoader(false);
        toast.error(e?.response?.data?.message);
      });
  };

  const getlist = (
    page: any,
    searchText?: any,
    order_by?: any,
    sort_by?: any
  ) => {
    
  const usedForParam = usedFor ?? "COURSE";
  // course_type filters `courses.type` (VFR / IFR). For the COURSE listing this
  // is the active tab; for the CERTIFICATE listing it's the type passed in the
  // URL. It must NOT be the raw `type` param (which can be "COURSE").
  const courseTypeParam =
    usedFor === "CERTIFICATE" ? type ?? "" : activeType;
    setShowLoader(true);
    const obj: any = { ...FilterObj };
    obj.offset = page ? page - 1 : 0;
    obj.keyword = searchText ?? "";
    if (order_by) obj.order_by = order_by;
    if (sort_by) obj.sort_by = sort_by;

    setFilterObj(obj);
    ShareService.setMapValue("listing-levels-filter", obj);

    const queryParams = new URLSearchParams({
      keyword: obj.keyword || "",
      sort_by: obj.sort_by || "ordering",
      order_by: obj.order_by || "asc",
      offset: obj.offset.toString(),
      limit: "50",
      ...(id ? { course_id: id } : {}),
      course_type: courseTypeParam,
      used_for: usedForParam,
    }).toString();

    WebService.getAPI({
      action: `/levels/list?${queryParams}`,
      body: obj,
    })
      .then((res: any) => {
        setShowLoader(false);
        setCount(res.count);
        setAllData(res.list || []);

        let rows: GridRow[] = [];
        res.list.forEach((item: any, i: number) => {
          let columns: GridColumn[] = [];
          columns.push({ value: i + 1 });
          columns.push({
            value: HelperService.getFormatedDate(item.created_at),
          });
          columns.push({ value: item.title });
          columns.push({ value: item.course_type });
          columns.push({ value: Lessons(item) });
          columns.push({ value: actionList(item, permissions) });
          rows.push({ data: columns });
        });
        setRows(rows);
      })
      .catch(() => setShowLoader(false));
  };

  const showAccessDenied = () => toast.error("Access Denied");

  const Lessons = (data: any) => (
    <div className="action-btns text-left">
         <Link
      to={`/lessons/${data.uuid}`}
     
      className="text-blue p-1 me-1 text-bold"
      style={{ textDecoration: "none" }}
    >
      View
    </Link>
    </div>
  );

  const actionList = (data: any, perms: any) => {
    const p = perms ?? permissions;
    return (
      <div className="action-btns text-left">
        {p.can_update ? (
          <a
            href={`/levels/${data.uuid}`}
            className="text-dark p-1 me-1"
            title="Edit"
          >
            <FiEdit size={18} />
          </a>
        ) : (
          ""
        )}
        {p.can_delete ? (
          <button
            className="text-danger btn btn-link p-1"
            title="Delete"
            onClick={() => handleDelete(data.uuid, p)}
          >
            <FiTrash2 size={18} />
          </button>
        ) : (
          ""
        )}
      </div>
    );
  };

  const handleDelete = (id: any, perms?: any) => {
    const p = perms ?? permissions;
    // if (!p?.can_delete) return showAccessDenied();
    setShowModal(true);
    setRequest(id);
  };

  // ✅ DRAG + DROP — reorder by `ordering`
  // const handleDragEnd = async (result: any) => {
  //   if (!result.destination) return;

  //   const filtered = [...allData]
  //     .filter((x) => x.course_type === activeType)
  //     .sort((a, b) => a.ordering - b.ordering);

  //   const [moved] = filtered.splice(result.source.index, 1);
  //   filtered.splice(result.destination.index, 0, moved);

  //   const newOrder = filtered.map((x, i) => ({
  //     uuid: x.uuid,
  //     ordering: i + 1,
  //   }));

  //   try {
  //     await WebService.postAPI({
  //       action: "/levels/reorder",
  //       body: { order: newOrder },
  //     });
  //     toast.success("Order updated successfully");
  //     getlist(1);
  //   } catch {
  //     toast.error("Failed to update order");
  //   }
  // };
const handleDragEnd = async (result: any) => {
  if (!result.destination) return;

  let filtered = [...allData];

  if (type === "COURSE" || !type) {
    filtered = filtered
      .filter((x) => x.course_type === activeType)
      .sort((a, b) => a.ordering - b.ordering);
  }

  if (type === "CERTIFICATE") {
    filtered = filtered.sort((a, b) => a.ordering - b.ordering);
  }

  const [moved] = filtered.splice(result.source.index, 1);
  filtered.splice(result.destination.index, 0, moved);

  // New order payload
  const newOrder = filtered.map((x, i) => ({
    uuid: x.uuid,
    ordering: i + 1,
  }));

  try {
    await WebService.postAPI({
      action: "/levels/reorder",
      body: { order: newOrder },
    });

    toast.success("Order updated successfully");
    getlist(1);
  } catch {
    toast.error("Failed to update order");
  }
};

  const filteredList =
    type === "COURSE"
      ? allData
          .filter((r) => r.course_type === activeType)
          .filter((l) =>
            l.title?.toLowerCase().includes(searchKeyword.toLowerCase())
          )
          .sort((a, b) => a.ordering - b.ordering)
      : allData
          .filter((l) =>
            l.title?.toLowerCase().includes(searchKeyword.toLowerCase())
          )
          .sort((a, b) => a.ordering - b.ordering);

  const headers: GridHeader[] = [
    { title: "Sr No", width: 100, class: "", isSorting: false, sortingKey: "" },
    {
      title: "Date",
      width: 300,
      class: "",
      isSorting: true,
      sortingKey: "created_at",
    },
    {
      title: "Levels",
      width: 300,
      class: "",
      isSorting: true,
      sortingKey: "title",
    },
    { title: "Types", isSorting: true, sortingKey: "course_type", width: 300 },
    { title: "Lessons", width: 150, class: "" },
    { title: "Action", width: 150, class: "" },
  ];

  return (
    <div className="dashboard-content">
      <Row className="mb-3 align-items-center justify-content-between">
        <Col lg={7}>
          <h1 className="font-20 font-bold mb-0">
            Manage Levels
            {usedFor === "CERTIFICATE" && certificateTitle
              ? ` - ${certificateTitle}`
              : ""}
          </h1>
        </Col>

        <Col lg={3} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <InputGroup.Text>
              <IoSearchOutline size={18} />
            </InputGroup.Text>
            <Form.Control
              placeholder="Search..."
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyUp={(e) => getlist(1, e.currentTarget.value)}
            />
          </InputGroup>
        </Col>
        <Col lg={2}>
          {/* {permissions.can_create ? ( */}
          <Link
            to={`/levels/add?type=${type ?? "COURSE"}&course_type=${
              usedFor === "CERTIFICATE" ? type ?? "" : activeType
            }&used_for=${usedFor ?? "COURSE"}`}
            className="text-decoration-none"
          >
            <button className="btn btn-brand-1 d-block mx-auto">
              + Course Level
            </button>
          </Link>
          {/* ) : (
            ""
          )} */}
        </Col>
      </Row>

      {/* ✅ Tabs for VFR / IFR */}
      {usedFor === "CERTIFICATE" ? (
        ""
      ) : (
        <div className="tab-toggle-group mb-3 mt-3">
          <div className="btn-group" role="group">
            {["VFR", "IFR"].map((t) => (
              <button
                key={t}
                type="button"
                className={`tab-btn ${activeType === t ? "active" : ""}`}
                onClick={() => setActiveType(t)}
              >
                {t}
              </button>
            ))}
          </div>
        </div>
      )}

      <Loader show={ShowLoader} />

      {/* ✅ Drag & Drop Table */}
      <div className="p-2 card">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th style={{ width: "60px" }}>#</th>
              <th>Date</th>
              <th>Level Title</th>
              <th>Course Type</th>
              <th>Lessons</th>
              <th>Action</th>
            </tr>
          </thead>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="levels">
              {(provided) => (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {ShowLoader ? null : filteredList.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center py-4 text-muted">
                        No Records Found
                      </td>
                    </tr>
                  ) : (
                    filteredList.map((item, index) => (
                      <Draggable
                        key={item.uuid}
                        draggableId={item.uuid}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={`${
                              snapshot.isDragging ? "table-active" : ""
                            }`}
                            style={{
                              ...provided.draggableProps.style,
                              cursor: "grab",
                            }}
                          >
                            <td>{index + 1}</td>
                            <td>
                              {HelperService.getFormatedDate(item.created_at)}
                            </td>
                            <td className="fw-semibold">{item.title}</td>
                            <td>
                              <span
                                className="badge rounded-pill px-3 py-2 text-white"
                                style={{
                                  backgroundColor:
                                    item.course_type === "VFR"
                                      ? "#00bfa6"
                                      : "#00bfa6",
                                }}
                              >
                                {item.course_type}
                              </span>
                            </td>
                            <td>
                              <Link
                                to={`/lessons/${item.uuid}`}
                                 state={{ title: item.title }}
                                className="text-decoration-none text-primary fw-semibold"
                              >
                                View Lessons
                              </Link>
                            </td>
                            <td>
                              <div className="d-flex gap-2 align-items-center">
                                <button
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={() =>
                                    navigate(
                                      `/levels/${item.uuid}?type=${
                                        type ?? "COURSE"
                                      }`
                                    )
                                  }
                                >
                                  <FiEdit />
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDelete(item.uuid)}
                                >
                                  <FiTrash2 />
                                </button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>

      {showModal && (
        <LevelDeleteModal
          id={request}
          title="Are you sure you want to delete!"
          showModal={showModal}
          onCloseModel={() => {
            setShowModal(false);
            getlist(1, searchKeyword);
          }}
        />
      )}
    </div>
  );
};

export default CourseManagement;
